import React, { useState } from 'react';
import PropTypes from 'prop-types';
import upperFirst from 'lodash.upperfirst';
import { Checkboxes } from '@blaze-react/checkboxes';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { withTitle } from '../../../HOC';
import { decodeValue } from '../helpers';
import { LIMIT_MIN, LIMIT_MAX, MORE, LESS } from '../constants';
const Checkbox = ({
  data,
  prop,
  updateFilterValues,
  filterValues,
  label,
  elementTitle,
  shouldSearch,
  displayFilterCount
}) => {
  const [checkboxLimit, setCheckboxLimit] = useState(null);
  if (!data[prop]) return null;
  const handleCheckboxOptions = () => {
    if (checkboxLimit[prop] === LIMIT_MIN) {
      setCheckboxLimit({
        [prop]: LIMIT_MAX
      });
    } else {
      setCheckboxLimit({
        [prop]: LIMIT_MIN
      });
    }
  };
  if (!checkboxLimit) {
    setCheckboxLimit({
      [prop]: LIMIT_MIN
    });
  }
  if (!checkboxLimit) return null;
  let checkboxQueryParams = [];
  if (filterValues && filterValues[prop]) {
    checkboxQueryParams = typeof filterValues[prop] === 'string' ? [decodeValue(filterValues[prop])] : filterValues[prop].map(val => decodeValue(val));
  }
  const multiple = [];
  const sortedValues = data[prop].buckets.map(({
    key,
    doc_count: count
  }) => {
    const optionLabel = displayFilterCount ? `${key} (${count})` : key;
    return [key, optionLabel, !count];
  }).filter(Boolean).sort();
  sortedValues.forEach((value, i) => i < checkboxLimit[prop] && multiple.push({
    label: upperFirst(value[1]),
    value: value[0],
    name: prop,
    checked: checkboxQueryParams.includes(value[0]),
    id: value[0],
    disabled: value[2]
  }));
  const shouldDisplayMore = !checkboxLimit || checkboxLimit[prop] === LIMIT_MIN;
  return /*#__PURE__*/React.createElement(React.Fragment, null, label ? /*#__PURE__*/React.createElement("p", null, label) : '', /*#__PURE__*/React.createElement(Checkboxes, {
    className: "form-checkbox",
    options: multiple,
    onChange: ({
      data: eData
    }) => {
      const newCheckboxValues = eData.filter(({
        checked
      }) => checked).map(({
        value
      }) => value);
      updateFilterValues({
        [prop]: newCheckboxValues
      }, shouldSearch);
    }
  }), data[prop].buckets.length > LIMIT_MIN && /*#__PURE__*/React.createElement("div", {
    role: "button",
    className: "see-more",
    onClick: handleCheckboxOptions,
    "aria-label": shouldDisplayMore ? `See ${MORE} ${label} options` : `See ${LESS} ${label} options`
  }, shouldDisplayMore ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(FaChevronDown, {
    className: "inline-icon"
  })), ` See ${MORE}`) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(FaChevronUp, {
    className: "inline-icon"
  })), ` See ${LESS}`)));
};
Checkbox.propTypes = {
  data: PropTypes.object.isRequired,
  prop: PropTypes.string.isRequired,
  filterValues: PropTypes.object.isRequired,
  updateFilterValues: PropTypes.func.isRequired,
  shouldSearch: PropTypes.bool,
  label: PropTypes.string,
  elementTitle: PropTypes.string,
  displayFilterCount: PropTypes.bool
};
Checkbox.defaultProps = {
  shouldSearch: false,
  label: '',
  elementTitle: '',
  displayFilterCount: false
};
export default withTitle(Checkbox);
//# sourceMappingURL=Checkbox.js.map